import { BeneficiaryDto } from '../../models';

export const validateBeneficiary = (item: BeneficiaryDto) => {
  const fields: (keyof BeneficiaryDto)[] = [];

  if (typeof item.nickName !== 'string') fields.push('nickName');
  if (typeof item.firstName !== 'string') fields.push('firstName');
  if (typeof item.lastName !== 'string') fields.push('lastName');
  if (typeof item.email !== 'string') fields.push('email');

  return { valid: fields.length === 0, fields };
};
